import EditableTextArea from "./EditableTextArea";

const MessageToGuests = ({ rsvp, isEditable, onUpdate }) => {
  return (
    <div className={`w-full px-8 container flex flex-col items-center my-12 `}>
      <EditableTextArea
        text={rsvp.messageToGuestsText}
        className={`w-full text-xl leading-normal bg-transparent text-center mb-2 mx-auto font-${rsvp.messageToGuestsFont}`}
        onTextChange={(text) => onUpdate?.({ messageToGuestsText: text })}
        style={{
          color: rsvp.messageToGuestsColor,
          fontSize: `${rsvp.messageToGuestsFontSize}px`,
        }}
        font={rsvp.messageToGuestsFont}
        color={rsvp.messageToGuestsColor}
        fontSize={rsvp.messageToGuestsFontSize}
        onStyleChange={(style) => {
          if (style.font) onUpdate({ messageToGuestsFont: style.font });
          if (style.color) onUpdate({ messageToGuestsColor: style.color });
          if (style.fontSize)
            onUpdate({ messageToGuestsFontSize: style.fontSize });
          if (style.isBold !== undefined)
            onUpdate({ messageToGuestsIsBold: style.isBold });

          if (style.isItalic !== undefined)
            onUpdate({ messageToGuestsIsItalic: style.isItalic });
        }}
        isEditable={isEditable}
        isBold={rsvp.messageToGuestsIsBold}
        isItalic={rsvp.messageToGuestsIsItalic}
        rows={5} // Provide more initial rows for the message
      />
    </div>
  );
};

export default MessageToGuests;
